import { createContext, useContext } from "react";
import { processDataProps } from '../components/DataSource/processProps';
import Status from '../components/DataSource/status';
import { CONTENT_VARIABLES } from "../components/DataSource/contentVariables";

const PagePropContext = createContext<any>({});

export const usePageProps = () => {
    const pageProps = useContext(PagePropContext);
    const newProps = processDataProps(CONTENT_VARIABLES, pageProps, Status.LOADING);
    return newProps;
};
export default PagePropContext;